var getDeviceByScreenSize = function getDeviceByScreenSize() {
  return window.screen.width > 768 ? 'desktop' : 'mobile';
};

export default getDeviceByScreenSize;